<!-- @format -->

<template>
	<div class="qrCode">
		<el-icon><Qrcode @click="visible = true" /></el-icon>
		<el-dialog v-model="visible" width="30%" @close="visible = false">
			<div class="qrCode-content">
				<img :src="src" width="200" height="200" />
			</div>
		</el-dialog>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		src: string;
	}

	withDefaults(defineProps<Props>(), {});

	const visible = ref<boolean>(false);
</script>

<style scoped lang="scss">
	.qrCode {
		cursor: pointer;
		color: var(--el-color-primary);
		display: flex;
		align-items: center;

		.qrCode-content {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
</style>
